
const blogPosts = [
  {
    category: 'お知らせ',
    date: '2025年1月15日',
    title: '2025年4月 新規開業のお知らせ',
    excerpt: '2025年4月より、岡山市北区にて「おかやま鍼灸院」を開業いたします。地域の皆様の健康をサポートできるよう、スタッフ一同精進してまいります。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/80bd6f80d8b719295486b6c0a00ef4ca.jpeg',
    bgColor: 'bg-sub',
  },
  {
    category: '健康情報',
    date: '2025年1月10日',
    title: '冬の冷え性対策 - お灸の効果について',
    excerpt: '寒い季節に多くの方が悩む冷え性。お灸治療は血行を促進し、体の内側から温める効果があります。当院でのお灸治療についてご紹介します。',
    image: 'https://public.readdy.ai/ai/img_res/7975654f578582a75bb7434c70b233f6.jpg',
    bgColor: 'bg-accent/20',
  },
  {
    category: '施術紹介',
    date: '2025年1月5日',
    title: '美容鍼で内側から輝く肌へ',
    excerpt: '美容鍼は、顔のツボを刺激することで血行を促進し、リフトアップやシワ改善に効果的です。化粧品では届かない深部からのアプローチで、自然な美しさを引き出します。',
    image: 'https://readdy.ai/api/search-image?query=Serene%20Japanese%20woman%20receiving%20facial%20acupuncture%20beauty%20treatment%2C%20delicate%20needles%20on%20face%2C%20peaceful%20expression%2C%20modern%20aesthetic%20clinic%20with%20soft%20lighting%2C%20professional%20beauty%20therapy%2C%20natural%20rejuvenation%20concept%2C%20high%20quality%20beauty%20photography&width=800&height=600&seq=blog-beauty-acupuncture&orientation=landscape',
    bgColor: 'bg-primary/10',
  },
  {
    category: '健康情報',
    date: '2024年12月28日',
    title: '肩こり解消のための日常ケア',
    excerpt: 'デスクワークで肩こりに悩む方が増えています。鍼灸治療と合わせて、日常でできる簡単なストレッチやケア方法をご紹介します。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/0dc1f9e31e47ed8fbacf6c8a518c5713.jpeg',
    bgColor: 'bg-sub',
  },
  {
    category: 'スタッフ紹介',
    date: '2024年12月20日',
    title: '院長からのご挨拶',
    excerpt: '2000年の開業以来、岡山市を中心に地域の皆様の健康をサポートしてまいりました。一人ひとりに寄り添った治療を心がけています。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/beb6caac6d7d05a93b72d36fbb12a7cf.jpeg',
    bgColor: 'bg-accent/20',
  },
  {
    category: '健康情報',
    date: '2024年12月15日',
    title: '自律神経を整える鍼灸治療',
    excerpt: 'ストレスや不規則な生活で乱れがちな自律神経。鍼灸治療は自律神経のバランスを整え、不眠やめまいなどの症状改善に効果的です。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/b8b506abfb92406a49936c6896470371.jpeg',
    bgColor: 'bg-primary/10',
  },
];

const BlogList = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden hover:shadow-xl transition-all cursor-pointer group"
            >
              <div className="h-48 sm:h-56 md:h-64 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className={`${post.bgColor} p-6 sm:p-8`}>
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <span className="bg-white px-2 sm:px-3 py-1 rounded-full text-primary text-xs font-medium">
                    {post.category}
                  </span>
                  <span className="text-gray-600 text-xs">{post.date}</span>
                </div>
                <h3 className="font-serif text-lg sm:text-xl text-gray-900 mb-2 sm:mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-700 text-xs sm:text-sm leading-relaxed line-clamp-3 mb-3 sm:mb-4">
                  {post.excerpt}
                </p>
                <div className="flex items-center gap-2 text-primary text-xs sm:text-sm font-medium group-hover:gap-3 transition-all">
                  <span>続きを読む</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <button className="bg-primary text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full font-medium text-sm sm:text-base hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer">
            もっと見る
          </button>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
